import React from 'react'

function Services() {
    const services = [
        {
            icon: 'bi-box-seam',
            title: 'General Warehousing',
            desc: 'Secure and spacious storage solutions for non-perishable goods and general merchandise.',
            points: [
                'Safe & secure storage',
                'Inventory management support',
                'Bulk & pallet storage',
                'Organized racking systems',
            ],
        },
        {
            icon: 'bi-truck',
            title: 'Logistics Support',
            desc: 'Integrated logistics and transportation services ensuring smooth movement of goods.',
            points: [
                'End-to-end supply chain support',
                'Real-time tracking',
                'Fast distribution network',
                'Trusted logistics partners',
            ],
        },
        {
            icon: 'bi-building',
            title: 'Custom Warehousing',
            desc: 'Flexible and scalable warehousing solutions tailored to business requirements.',
            points: [
                'Custom storage layouts',
                'Short-term & long-term storage',
                'Industry-specific facilities',
                'Cost-effective solutions',
            ],
        },
    ];

    return (
        <section
            className="services-section py-5 position-relative"
            style={{
                marginTop: "-250px",
                zIndex: 10,
            }}
        >
            <div className="container">
                <div className="row g-4">
                    {services.map((service, idx) => (
                        <div key={idx} className="col-md-4">
                            <div
                                className="card h-100 border-0 shadow-sm rounded-4 p-4 bg-white text-dark transition"
                                data-aos="zoom-in"
                                data-aos-delay={idx * 300}
                            >
                                <div className="fs-2 text-primary mb-3">
                                    <i className={`bi ${service.icon}`}></i>
                                </div>

                                <h5 className="fw-semibold">{service.title}</h5>
                                <p className="text-muted">{service.desc}</p>

                                <ul className="ps-3">
                                    {service.points.map((point, i) => (
                                        <li key={i}>{point}</li>
                                    ))}
                                </ul>

                                <button className="btn btn-sm btn-primary mt-3">
                                    Learn More
                                </button>
                            </div>

                        </div>
                    ))}
                </div>
            </div>
            <style>
                {`
                    .card:hover {
                    transform: translateY(-10px);
                    background-color: #091a3a;
                    box-shadow: 0 1rem 3rem rgba(0,0,0,.175) !important;
                    color: white;
                    transition: all 0.1s ease;
                    }
                    .card:hover .btn {
                    background-color: white !important;
                    color: #084298 !important;
                    }

                 `}
            </style>


        </section>
    );
}


export default Services